export enum BillingCategory {
    ACH = 'ACH',
    WIRE = 'Wire',
    TRANSFER = 'Transfer',
    POSITIVE_PAY = 'Positive Pay',
    STOP_PAYMENT = 'Stop payment',
    ACCOUNT_RECONCILIATION = 'Account Reconciliation Reporting',
}

export enum BillingRoute {
    ACH = 'ach',
    WIRE = 'wire',
    ACCOUNT_RECONCILIATION = 'account-reconciliation',
    POSITIVE_PAY = 'positive-pay',
    TRANSFER = 'transfer',
    STOP_PAYMENT = 'stop-payment',
}

export enum BillingTransactionLabels {
    ACCOUNT_RECONCILIATION = 'Account Reconciliation',
    ACH = 'ACH',
    WIRE = 'Wires',
    TRANSFER = 'Transfers',
    POSITIVE_PAY = 'Positive Pay',
    STOP_PAYMENT = 'Stop payments',
}

export enum BillingAnalysisTransactionTypeCategoryId {
    // This data is managed controlled on the server-side. This is mock data that currently matches the backend data.
    // Once the API is integration is complete these values will need to be updated based on the API response
    ACH = 1,
    WIRE = 2,
    TRANSFER = 3,
    POSITIVE_PAY = 4,
    STOP_PAYMENT = 5,
    ACCOUNT_RECONCILIATION = 6,
}

export interface BillingNavOption {
    categoryName: BillingCategory;
    id: BillingAnalysisTransactionTypeCategoryId;
}

export interface CustomTransactionCode {
    accountCustomTransactionCodes: string[];
    active: boolean;
    analysisTransactionTypeCategoryId: number;
    analysisTransactionTypeId: number;
    id: number;
    transactionCode: string;
}
